<template>
  <path
    d="M9.00001 16.1702L5.53001 12.7002C5.14002 12.3102 4.51001 12.3102 4.12001 12.7002C3.73001 13.0902 3.73001 13.7202 4.12001 14.1102L8.30001 18.2902C8.69001 18.6802 9.32001 18.6802 9.71001 18.2902L20.29 7.71019C20.68 7.32019 20.68 6.69019 20.29 6.30019C19.9 5.91019 19.27 5.91019 18.88 6.30019L9.00001 16.1702Z"
  />
</template>
